import { ShieldCheck } from "lucide-react";
import { partners } from "@/mock/mock";

export default function Partners() {
  const items = [...partners, ...partners];
  return (
    <section className="py-16 border-y border-white/10 bg-brand-navy2/40 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6">
        <p className="text-center text-sm font-medium text-slate-400">
          In partnership with world-class cyber security technology vendors
        </p>
      </div>
      <div className="relative mt-8">
        <div className="flex w-max animate-marquee gap-4">
          {items.map((p, i) => (
            <div key={i} className="flex items-center gap-3 rounded-full border border-white/10 bg-white/5 px-6 py-3 whitespace-nowrap">
              <ShieldCheck className="h-4 w-4 text-brand-lime" />
              <span className="text-sm font-medium text-slate-300">{p}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
